import React, {useContext, useEffect} from 'react'
import styles from '../../../CSS/main.css'
import classNames from 'classnames'
import {Col} from '../List/Col'
import WelcomeMessage from './WelcomeMessage'
import UserBlock from './UserBlock'
import useDimensions from 'react-cool-dimensions'
import {DimensionsContext} from '../../utils/dimensions-context'
import {PortalType, Slot} from '../Portal'
import {User} from "../List/Item/CommentsItem";
import {getMe, getPendingCommentCount} from "../../api/requests";
import {useAsync} from "react-async-hook";
import {PendingCountResponse} from "../../../../types";
import { DEFAULT_TENANT_ID, TENANT_ID } from '../../constants'

const useHeaderState = () => {
  const fetchUser = useAsync<User>(getMe, [])
  const fetchPendingCount = useAsync<PendingCountResponse>(getPendingCommentCount, [])

  return {
    user: fetchUser.result,
    pendingCount: fetchPendingCount.result?.pendingCount,
  }
}

const Header: React.VFC = () => {
  const { observe, height, unobserve } = useDimensions<HTMLDivElement>({
    useBorderBoxSize: true,
  })
  const { update } = useContext(DimensionsContext)
  const { user, pendingCount } = useHeaderState()

  useEffect(() => {
    update({ headerHeight: height })
  }, [height])

  useEffect(() => {
    return () => {
      unobserve()
    }
  }, [])

  return (
    <div className={styles.TopUI} ref={observe}>
      {!!pendingCount && Boolean(user) && (
        <WelcomeMessage pendingCount={pendingCount} user={user}/>
      )}

      <div className={styles.Navigation}>
        <div className={classNames([styles.Table, styles.NavTable])}>
          <Col additionalClassNames={[styles.NavMenu]}>
            <Slot name={PortalType.Burger} />
          </Col>
          <Col additionalClassNames={[styles.NavLogo]}>
            <img className={classNames([TENANT_ID === DEFAULT_TENANT_ID ? styles.IconLogo : styles.IconLogoNewVideos])} />
          </Col>

          <Col additionalClassNames={[styles.NavInfo]} />
          {Boolean(user) && <UserBlock user={user} />}
        </div>
      </div>
    </div>
  )
}

export default Header
